<div style="text-align: center">
  <h1 style="font-family: Exo, sans-serif; font-weight: bold; padding-top: 10px" mat-dialog-title>Attenzione!</h1>
  <div mat-dialog-content style="padding-top: 5px">
    <p>{{message}}</p>
  </div>
  <div mat-dialog-actions style="justify-content: center;">
    <button mat-raised-button color="warn" [mat-dialog-close]="response">Conferma</button>
    <button mat-raised-button color="primary" (click)="cancel()">Annulla</button>
  </div>
</div>
